"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareErc721TemplatesInitialValues = exports.erc721TemplatesEditFilter = exports.erc721TemplatesCreateFilter = void 0;
const exchange_1 = require("@framework/exchange");
const types_1 = require("../../../../types");
const erc721TemplatesCreateFilter = ({ title, description, price, amount, imageUrl, contractId, }) => ({
    title,
    description,
    price: (0, exchange_1.cleanUpAsset)(price),
    amount,
    imageUrl,
    contractId,
});
exports.erc721TemplatesCreateFilter = erc721TemplatesCreateFilter;
const erc721TemplatesEditFilter = ({ title, description, price, amount, imageUrl, templateStatus, }) => ({
    title,
    description,
    price: (0, exchange_1.cleanUpAsset)(price),
    amount,
    imageUrl,
    templateStatus,
});
exports.erc721TemplatesEditFilter = erc721TemplatesEditFilter;
const prepareErc721TemplatesInitialValues = (service, merchantId) => ({ id, title, description, price, amount, templateStatus, contractId, imageUrl }) => {
    return {
        id,
        title,
        description,
        price,
        amount,
        templateStatus,
        contractId,
        imageUrl,
        // this is only filter for contract autocomplete
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareErc721TemplatesInitialValues = prepareErc721TemplatesInitialValues;
//# sourceMappingURL=schemas.js.map